import {css} from "styled-components"

export const mainStyles = css`
  background-color: ${({theme}) => theme.colors.utility.white};
  border-radius: 4px;
`

export const extraSmallStyles = css`
  width: 50px;
  height: 50px;
`

export const smallStyles = css`
  width: 60px;
  height: 60px;
`

export const regularStyles = css`
  width: 80px;
  height: 80px;
`

export const mediumStyles = css`
  width: 96px;
  height: 96px;
`

export const largeStyles = css`
  width: 140px;
  height: 140px;
`
